import type { Role } from '@polyai/common/types/resources/userManagement';

export type AccountResponse = {
  id: string;
  name: string;
  created_at: string;
  created_by: string;
  active: boolean;
  conversation_limits: {
    call_duration_limit: number;
    chat_turn_limit: number;
    account_type?: AccountType;
    max_concurrent_call?: number;
    /** @deprecated use account_restrictions */
    trial_days?: number;
  };
  role: Role.MEMBER | Role.ADMIN;
  type: AssistantType;
  account_restrictions?: AccountRestrictions;
};

export type AccountRestrictions = {
  account_id: string;
  created_at: string;
  disabled: boolean;
  trial_expires?: string;
  updated_at: string;
};

export enum AccountType {
  TRIAL = 'trial',
  STANDARD = 'standard',
  ENTERPRISE = 'enterprise',
}

export enum AssistantType {
  GENAI = 'genai',
  INTENT = 'intent',
  HYBRID = 'hybrid',
}

export type AccountsResponse = AccountResponse[];

export type AuthoriseResponse = {
  isAuthorised: boolean;
  user: {
    email: string;
    is_first_login: boolean;
  };
};

export type AccountRestrictionsRequest = {
  trial_expires?: string;
  disabled?: boolean;
};

export type AccountRestrictionsResponse = AccountRestrictions;
